import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import { useSearchParams } from "react-router-dom";
import Hosted from "../hosted";
import Liked from "../liked";
import { useTheme } from "../../../../../../context/themeContext";
import { useSelector } from "react-redux";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: "1rem" }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = useState(0);
  const { theme, darkMode } = useTheme();
  const { likedProjects, hostedProjects } = useSelector(
    (state) => state.publicUser
  );
  const [searchParams] = useSearchParams();
  const tabName = searchParams.get("projects-tab");

  useEffect(() => {
    if (tabName === "liked") {
      setValue(1);
    } else if (tabName === "hosted") {
      setValue(0);
    }
  }, [tabName]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
          sx={{
            "& .MuiTab-root": {
              color: darkMode && theme.palette.darkgrey.darkgrey400,
              textTransform: "capitalize",
              "&.Mui-selected": {
                color: darkMode && theme.palette.darkgrey.darkgrey500,
              },
            },
          }}
        >
          <Tab
            sx={{ textTransform: "capitalize" }}
            label={`Hosted(${hostedProjects?.length || 0})`}
            {...a11yProps(0)}
          />
          <Tab
            sx={{ textTransform: "capitalize" }}
            label={`Liked(${likedProjects?.length || 0})`}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Hosted />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Liked />
      </CustomTabPanel>
    </Box>
  );
}
